<template>
    <div>
        <div class="float-left">
            <el-button
                v-if="hasRole(Roles.MAIN_ROLES)"
                @click="create()"
                type="primary"
                ><i class="mdi mdi-plus" /> Create</el-button
            >
            <el-button
                v-if="hasRole(Roles.MAIN_ROLES)"
                @click="addExisting()"
                type="primary"
                ><i class="mdi mdi-plus" /> Add Existing Manager
            </el-button>
        </div>
        <div class="clearfix"></div>
        <el-table row-key="id" :data="computedUsers">
            <el-table-column label="Name" prop="name">
                <template slot-scope="{ row }">
                    {{ row.name }}
                </template>
            </el-table-column>
            <el-table-column prop="email" label="Email" width="300px" />
            <el-table-column label="Username" prop="username" />
            <!--<el-table-column prop="phone_number" label="Phone Number" />-->
            <el-table-column prop="role" label="Role">
                <template slot-scope="scope">
                    {{ getRoleName(scope.row.role) }}
                </template>
            </el-table-column>
            <el-table-column prop="is_active" width="75px" label="Active">
                <template slot-scope="scope">
                    <i
                        class="mdi mdi-check success-text"
                        v-if="scope.row.is_active"
                    />
                    <i class="mdi mdi-close danger-text" v-else />
                </template>
            </el-table-column>
            <el-table-column
                prop="is_default_contact_for_community"
                width="85px"
                label="Default Contact"
            >
                <template slot-scope="scope">
                    <i
                        class="mdi mdi-check success-text"
                        v-if="scope.row.is_default_contact_for_community"
                    />
                    <i class="mdi mdi-close danger-text" v-else />
                </template>
            </el-table-column>
            <el-table-column prop="actions">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button
                            size="small"
                            icon="mdi mdi-pencil"
                            @click="editItem(scope.row)"
                            >Edit</el-button
                        >
                        <el-button
                            v-if="scope.row.id"
                            size="small"
                            type="danger"
                            :loading="
                                isItemBusy(scope.row, 'send password reset')
                            "
                            icon="mdi mdi-send"
                            @click="sendPasswordReset(scope.row)"
                            >Reset PW
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            :title="editingItem ? 'Edit User' : 'Create User'"
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="500px"
            append-to-body
        >
            <el-form @submit.prevent="submit()">
                <el-form-item
                    required
                    label="Name"
                    :class="userForm.state('name')"
                >
                    <el-input
                        name="name"
                        v-model="userForm.name"
                        v-validate="'required'"
                    />
                    <form-feedback :form="userForm" field="name" />
                </el-form-item>
                <el-form-item
                    required
                    label="Email"
                    :class="userForm.state('email')"
                >
                    <el-input
                        name="email"
                        v-validate="'required'"
                        v-model="userForm.email"
                    />
                    <form-feedback :form="userForm" field="email" />
                </el-form-item>
                <el-form-item
                    label="Phone Number"
                    :class="userForm.state('phone_number')"
                >
                    <el-input
                        name="phone_number"
                        v-model="userForm.phone_number"
                    />
                    <form-feedback :form="userForm" field="phone_number" />
                </el-form-item>
                <el-form-item
                    label="Job Title"
                    :class="userForm.state('job_title')"
                >
                    <el-input name="job_title" v-model="userForm.job_title" />
                    <form-feedback :form="userForm" field="job_title" />
                </el-form-item>
                <el-form-item
                    :class="userForm.state('username')"
                    label="Username"
                >
                    <el-input
                        name="username"
                        v-model="userForm.username"
                        v-validate="'alpha_dash'"
                    />
                    <form-feedback :form="userForm" field="username" />
                </el-form-item>
                <el-form-item
                    :required="!userForm.id"
                    label="Password"
                    :class="userForm.state('password')"
                >
                    <el-input
                        autocomplete="new-password"
                        data-vv-name="password"
                        show-password
                        type="password"
                        v-validate="userForm.id ? null : 'required'"
                        v-model="userForm.password"
                    />
                    <form-feedback :form="userForm" field="password" />
                </el-form-item>
                <el-form-item
                    required
                    label="Role"
                    :class="userForm.state('role')"
                    v-if="!readonly"
                >
                    <el-select
                        filterable
                        name="role"
                        v-validate="'required'"
                        v-model="userForm.role"
                        placeholder="Select"
                    >
                        <el-option
                            v-for="role in CommunityRoles"
                            :key="role"
                            :label="getRoleName(role)"
                            :value="role"
                        >
                        </el-option>
                    </el-select>
                    <form-feedback :form="userForm" field="role" />
                </el-form-item>
                <el-form-item
                    label="Active"
                    :class="userForm.state('is_active')"
                >
                    <el-switch v-model="userForm.is_active" />
                    <form-feedback :form="userForm" field="is_active" />
                </el-form-item>
                <el-form-item
                    label="Set as Default Contact"
                    :class="userForm.state('is_default_contact_for_community')"
                >
                    <el-switch
                        v-model="userForm.is_default_contact_for_community"
                    />
                    <form-feedback
                        :form="userForm"
                        field="is_default_contact_for_community"
                    />
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button
                    :disabled="userForm.busy"
                    @click="dialogVisible = false"
                    >Cancel</el-button
                >
                <el-button
                    @click="submit"
                    icon="mdi mdi-content-save"
                    type="primary"
                    >Save
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            v-if="hasRole(Roles.MAIN_ROLES)"
            :close-on-click-modal="false"
            :visible.sync="addExistingDialogVisible"
            title="Add Existing Manager"
            width="1000px"
        >
            <user-finder
                :except-users="users"
                @selection-change="onUserSelectionChange"
                ref="userFinder"
                :role="[Roles.COMMUNITY_MANAGER]"
                v-if="addExistingDialogVisible"
                :corporation="corporation"
            />
            <div slot="footer" class="dialog-footer">
                <el-button @click="addExistingDialogVisible = false"
                    >Cancel</el-button
                >
                <el-button
                    :disabled="selectedUsers.length === 0"
                    @click="confirmAddExisting"
                    type="primary"
                >
                    OK
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import UserFinder from "@/components/user/Finder";
import * as CommunityRoles from "@/constants/community-roles";
import auth from "@/mixins/auth";
import password_reset_mixin from "@/mixins/user/password-reset.js";

export default {
    mixins: [auth, password_reset_mixin],
    props: {
        form: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        community: {
            type: Object,
            required: false
        },
        corporation: {
            type: Object,
            required: false
        }
    },
    components: {
        UserFinder
    },
    data() {
        return {
            CommunityRoles,
            dialogVisible: false,
            addExistingDialogVisible: false,
            userForm: new Form({
                id: null,
                name: null,
                email: null,
                username: null,
                phone_number: null,
                job_title: null,
                role: null,
                is_active: true,
                parent_id: null,
                parent_ids: [],
                password: null,
                is_default_contact_for_community: false,
                community_id: null,
                // Add subscription preferences
                subscribe_to_order_reminders: false,
                subscribe_to_invoice_emails: true,
                subscribe_to_suspension_emails: true
            }),
            editingItem: null,
            validationForm: new Form({
                users: []
            }),
            users: [],
            selectedUsers: [],
            oldData: null,
            community_default_contact_id: null
        };
    },
    created() {
        if (this.community) {
            this.getUsers();
            this.community_default_contact_id =
                this.community.default_contact_id;
        }
    },
    mounted() {
        this.userForm.setVeeErrors(this.veeErrors);
    },
    watch: {
        "community.id"() {
            this.form.community_id = this.community.id;
            this.community_default_contact_id =
                this.community.default_contact_id;
            this.users = [];
            this.getUsers();
        }
    },
    computed: {
        computedUsers() {
            return this.users;
        }
    },
    methods: {
        getUsers() {
            axios
                .get(`/web-api/user`, {
                    params: {
                        community_id: this.community.id,
                        include: "roles"
                    }
                })
                .then((response) => {
                    let userData = response.data.data;
                    this.form.users = userData.map((user) => {
                        return {
                            ...user,
                            role: _.get(user, "roles.data.0.role"),
                            is_default_contact_for_community:
                                this.community_default_contact_id === user.id,
                            community_id: this.community
                                ? this.community.id
                                : null
                        };
                    });
                    this.users = this.form.users;
                });
        },
        create() {
            this.editingItem = null;
            this.dialogVisible = true;
            this.userForm.clearFields();
            if (this.community) {
                this.userForm.parent_ids = [this.community.id];
            }
        },
        onUserSelectionChange(users) {
            this.selectedUsers = users;
        },
        addExisting() {
            this.selectedUsers = [];
            this.addExistingDialogVisible = true;
        },
        confirmAddExisting() {
            this.selectedUsers.forEach((user) => {
                let data = _.pick(user, [
                    "id",
                    "name",
                    "email",
                    "username",
                    "is_active",
                    "phone_number",
                    "job_title"
                ]);
                data.role = CommunityRoles.COMMUNITY_MANAGER;
                this.form.users.push(data);
            });
            this.addExistingDialogVisible = false;
        },
        submit() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    console.log("not valid");
                    return;
                }
                if (this.editingItem) {
                    axios
                        .put(
                            `/web-api/user/${this.editingItem.id}?include=roles`,
                            this.userForm
                        )
                        .then((response) => {
                            if (
                                this.userForm
                                    .is_default_contact_for_community === true
                            ) {
                                this.community_default_contact_id =
                                    this.userForm.id;
                            } else {
                                if (
                                    this.community_default_contact_id ===
                                    this.userForm.id
                                ) {
                                    this.community_default_contact_id = null;
                                }
                            }
                            this.dialogVisible = false;
                            this.getUsers();
                            this.$notify.success({
                                message: `Changes have been saved`
                            });
                        })
                        .catch((error) => {
                            console.log("error", error.response);
                            this.$notify.error({
                                message: error.response
                                    ? `${
                                          error.response.data.message
                                      } \n${this.getErrorMessages(error)}`
                                    : "ERROR: changes have not been saved"
                            });
                        });
                } else {
                    axios
                        .post(`/web-api/user`, this.userForm)
                        .then((response) => {
                            if (
                                this.userForm
                                    .is_default_contact_for_community === true
                            ) {
                                this.community_default_contact_id =
                                    response.data.id;
                            }
                            this.dialogVisible = false;
                            this.getUsers();
                            this.$notify.success({
                                message: `User added`
                            });
                        })
                        .catch((error) => {
                            console.log("error", error.response);
                            this.$notify.error({
                                message: error.response
                                    ? `${
                                          error.response.data.message
                                      } \n${this.getErrorMessages(error)}`
                                    : "ERROR: user was not added"
                            });
                        });
                }
            });
        },
        editItem(item) {
            this.userForm.clearFields();
            axios
                .get(`/web-api/user/${item.id}`, {
                    params: {
                        include: "roles.parent"
                    }
                })
                .then((response) => {
                    let user = response.data;
                    _.extend(
                        this.userForm,
                        _.pick(user, [
                            "id",
                            "name",
                            "email",
                            "username",
                            "is_active",
                            "is_default_contact_for_community",
                            "phone_number",
                            "job_title"
                        ])
                    );
                    this.userForm.role = _.get(user, "roles.data.0.role");
                    if (
                        this.userForm.role ===
                            CommunityRoles.COMMUNITY_MANAGER ||
                        this.userForm.role ===
                            CommunityRoles.COMMUNITY_ACCOUNTANT
                    ) {
                        _.forEach(user.roles.data, (role) => {
                            this.userForm.parent_ids.push(role.parent_id);
                        });
                    } else {
                        this.userForm.parent_id = _.get(
                            user,
                            "roles.data.0.parent_id"
                        );
                    }
                    this.userForm.community_id = this.community.id;
                    this.userForm.is_default_contact_for_community =
                        this.userForm.id === this.community.default_contact_id;
                    this.editingItem = item;
                    this.dialogVisible = true;
                    this.initOldData();
                });
        },
        initOldData() {
            this.oldData = JSON.stringify(this.getCleanFormData());
        },
        getCleanFormData() {
            return _.pick(this.userForm, [
                "name",
                "email",
                "username",
                "is_active",
                "is_default_contact_for_community",
                "phone_number",
                "job_title",
                "role",
                "parent_id"
            ]);
        },
        getErrorMessages(error) {
            let error_messages = "";
            if (error.response.data.errors) {
                Object.values(error.response.data.errors).forEach((val) => {
                    if (val) {
                        error_messages += `\n${val}`;
                    }
                });
            }
            return error_messages;
        }
    }
};
</script>

<style scoped></style>
